export const documentRequestStatusValues = [
  'request',
  'production',
  'pending',
  'approved',
  'waiting_implementation',
  'implemented',
  'rejected',
] as const;

export type DocumentRequestStatus =
  (typeof documentRequestStatusValues)[number];

export type StatusOption = { label: string; value: DocumentRequestStatus };

export const statusMap: Record<DocumentRequestStatus, StatusOption> = {
  request: { label: 'Solicitação', value: 'request' } as const,
  production: { label: 'Em produção', value: 'production' } as const,
  pending: { label: 'Aguardando aprovação', value: 'pending' } as const,
  approved: { label: 'Aprovado', value: 'approved' } as const,
  waiting_implementation: {
    label: 'Aguardado implementação',
    value: 'waiting_implementation',
  } as const,
  implemented: { label: 'Implementado', value: 'implemented' } as const,
  rejected: { label: 'Não aprovado', value: 'rejected' } as const,
};

export const statusOptions = [
  statusMap.request,
  statusMap.production,
  statusMap.pending,
  statusMap.approved,
  statusMap.waiting_implementation,
  statusMap.implemented,
  statusMap.rejected,
];

export type Status = (typeof statusOptions)[number];

export const tenantNextStatusMap: Record<
  DocumentRequestStatus,
  DocumentRequestStatus[]
> = {
  request: ['request', 'production', 'rejected'],
  production: [
    'production',
    'pending',
    'approved',
    'waiting_implementation',
    'implemented',
    'rejected',
  ],
  pending: ['pending', 'approved', 'rejected'],
  approved: ['approved', 'waiting_implementation', 'implemented', 'rejected'],
  waiting_implementation: ['waiting_implementation', 'implemented', 'rejected'],
  implemented: ['implemented'],
  rejected: ['rejected'],
};

export const companyNextStatusMap: Record<
  DocumentRequestStatus,
  DocumentRequestStatus[]
> = {
  request: [],
  production: [],
  pending: ['approved', 'rejected'],
  approved: [],
  waiting_implementation: [],
  implemented: [],
  rejected: [],
};
